<template>
  <div class="">
    <stats-card :type="'primary'" icon="fa fa-bar-chart font-100 mt-40" :small-title="'Total Sales Today'" :title="money(amount)">
      <div class="stats link" slot="footer" @click="openLink('/client/reports/sold-tickets')">
        <i :class="'fa fa-external-link'"></i>
        View mores
      </div>
    </stats-card>
  </div>
</template>
<script>

import { Analytic } from '@/resources/analytics'
import StatsCard from '../../UIComponents/Cards/StatsCard.vue';

export default {
  components: {
    StatsCard
  },
  data() {
    return {
      amount: 0
    }
  },

  created: function () {
    this.getData()
  },
  methods: {
    getData() {
      let params = {}
      this.$loading = true
      Analytic.totalSalesToday(params)
        .then(result => {
          this.amount = result.data.amount
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
  }
}
</script>
<style lang="scss"></style>
